<template>
    <v-row>
        <div class="col-md-12 home-box">
            <Breadcrumbs :title="'Company Bank Accounts'"></Breadcrumbs>
            <BankAccTable></BankAccTable>
        </div>
    </v-row>
</template>
<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import BankAccTable from "@/components/CompanyBanks/AccountListTable.vue";

export default {
    name: 'batchList',
    components:{
        Breadcrumbs,
        BankAccTable
    }
}
</script>